package org.example.zone360.pages.dashboard

import RecommendationPopup
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.models.ToastPlacement
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaCopy
import com.varabyte.kobweb.silk.components.icons.fa.FaGear
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getAllTeams
import org.example.zone360.utils.getClubCoaches
import org.example.zone360.utils.getClubKeyword
import org.example.zone360.utils.getClubPerformance
import org.example.zone360.utils.getClubSeason
import org.example.zone360.utils.getClubSession
import org.example.zone360.utils.getClubWidgetData
import org.example.zone360.utils.getClubWidgets
import org.example.zone360.utils.getCustomKeyword
import org.example.zone360.utils.getPlayerAggregate
import org.example.zone360.utils.getProfile
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.async
import kotlinx.coroutines.launch
import org.example.zone360.components.BSToastBasicCustom
import org.example.zone360.components.BSToastGroupCustom
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.DashboardChatOverlay
import org.example.zone360.components.GetClubWidgetPayload
import org.example.zone360.components.SaveWidgetPayload
import org.example.zone360.components.SeasonSelectorPopover
import org.example.zone360.components.WidgetSelectionPopup
import org.example.zone360.components.WidgetSelectionValidationPopup
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.rememberWidgetRenderers
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.ClubWidgetPayload
import org.example.zone360.models.ClubWidgetResponse
import org.example.zone360.models.CustomKeywordPayload
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetAllTeamsData
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubPerformanceData
import org.example.zone360.models.GetClubSeasonData
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.coachDetails.coachAssistAi.isPaymentActive
import org.example.zone360.pages.dashboard.coaches.AddNewCoach
import org.example.zone360.pages.dashboard.coaches.CoachLimitReachedPopup
import org.example.zone360.pages.dashboard.coaches.CoachesCount
import org.example.zone360.pages.dashboard.coaches.CoachesLayout
import org.example.zone360.pages.dashboard.coaches.ImportEntity
import org.example.zone360.pages.dashboard.dashboardAssistantAI.DashboardChatbot
import org.example.zone360.pages.dashboard.dashboardAssistantAI.ResponsiveDashboardChatbot
import org.example.zone360.pages.dashboard.keywordUsage.KeywordUsage
import org.example.zone360.pages.dashboard.paymentPopup.AnnualSubscriptionsPayment
import org.example.zone360.pages.dashboard.paymentPopup.ClubCoachPaymentPopup
import org.example.zone360.pages.dashboard.playerAssessment.AddNewPlayer
import org.example.zone360.pages.dashboard.playerAssessment.PlayerRecommendationPopup
import org.example.zone360.pages.dashboard.recentHighlight.RecentHighlight
import org.example.zone360.pages.dashboard.seasonSection.CreateClubSeason
import org.example.zone360.pages.dashboard.seasonSection.DeleteSeason
import org.example.zone360.pages.dashboard.teamSection.TeamSections
import org.example.zone360.sections.DashboardHeaderSection
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.AppGlobal.Companion.clubCoachesList
import org.example.zone360.utils.AppGlobal.Companion.clubKeywordsList
import org.example.zone360.utils.AppGlobal.Companion.clubSessionList
import org.example.zone360.utils.AppGlobal.Companion.keywordResponse
import org.example.zone360.utils.AppGlobal.Companion.seasonDataList
import org.example.zone360.utils.AppGlobal.Companion.teamDataList
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.getCurrentMilliseconds
import org.example.zone360.utils.injectChatAnimationStyles
import org.example.zone360.utils.injectMarkdownStyles
import org.example.zone360.utils.isBeforeCutoff
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.saveWidgetConfig
import kotlin.coroutines.cancellation.CancellationException

@Page("/home")
@Composable
fun DashboardPage() {
    val ctx = rememberPageContext()
    if (ctx.isExporting) return

    val scope = rememberCoroutineScope()
    var performanceResponse by remember { mutableStateOf(GetClubPerformanceData()) }
    var selectedCoach by remember { mutableStateOf(GetClubCoachesData()) }
    var selectedPlayer by remember { mutableStateOf(GetPlayerData()) }
    var teamDataSingle by remember { mutableStateOf(GetAllTeamsData()) }
    var message by remember { mutableStateOf("") }
    var isChatOpen by remember { mutableStateOf(false) }
    var isChartLoading by remember { mutableStateOf(true) }
    var isKeywordLoading by remember { mutableStateOf(true) }
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var selectedLanguage by remember {
        mutableStateOf(
            when (localStorage.getItem("selectedLanguage")) {
                "it" -> SelectedLanguage.Italian
                else -> SelectedLanguage.English
            }
        )
    }
    var selectedDataType by remember {
        mutableStateOf(
            when (localStorage.getItem("selectedDataType")) {
                Strings.MATCH -> SelectedData.Matches
                else -> SelectedData.Training
            }
        )
    }
    var isRecommendationPopupVisible by remember { mutableStateOf(false) }
    var isPlayerRecommendationVisible by remember { mutableStateOf(false) }
    var openNewWindow by remember { mutableStateOf(false) }
    var isNewPlayerPopup by remember { mutableStateOf(false) }
    var isNewCoachPopup by remember { mutableStateOf(false) }
    var deletePlayerPopup by remember { mutableStateOf(false) }
    var isPaidAndUnexpired by remember { mutableStateOf(true) }
    var isCoachPaidAndUnexpired by remember { mutableStateOf(true) }
    var importPlayers by remember { mutableStateOf(false) }
    var importCoach by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var clubPlayersList by remember { mutableStateOf(emptyList<GetPlayerData>()) }
    var coachLimitReached by remember { mutableStateOf(false) }
    var caochesCount by remember { mutableStateOf(false) }
    var apiFetchTrigger by remember { mutableStateOf(0) }
    val userId = ctx.route.params["userId"]

    var coachProfile by remember { mutableStateOf<GetSingleCoachData?>(null) }
    var allSessions by remember { mutableStateOf<List<GetSessionsData>>(emptyList()) }
    var showOverlay by remember { mutableStateOf(false) }
    var subscriptionPopup by remember { mutableStateOf(false) }
    var coachPlayerList by remember { mutableStateOf(emptyList<GetPlayerData>()) }
    var isSeasonInitialized by remember { mutableStateOf(false) }

    //
    var selectedSeasonData by remember { mutableStateOf(GetClubSeasonData()) }
    var isEditMode by remember { mutableStateOf(false) }
    var isClubSeason by remember { mutableStateOf(false) }
    var deleteSeason by remember { mutableStateOf(false) }
    var selectedSeason by remember { mutableStateOf("") }
    var clubWidgetResponse by remember { mutableStateOf<ClubWidgetResponse?>(null) }
    var isWidgetLoading by remember { mutableStateOf(false) }
    var selectedWidget by remember { mutableStateOf(emptySet<Int>()) }
//    val sharedChatMessages = remember {
//        mutableStateListOf<ChatBotMessage>()
//    }
    LaunchedEffect(Unit) {
        injectMarkdownStyles()
        injectChatAnimationStyles()
    }
    val chatState = remember {
        DashboardChatState()
    }

    val defaultWidgetIds = setOf(1, 2, 3, 4)
    var selectedWidgetIds by remember { mutableStateOf(defaultWidgetIds) }
    var tempSelectedWidgetIds by remember { mutableStateOf(defaultWidgetIds) }

    var showWidgetValidationPopup by remember { mutableStateOf(false) }
    var showWidgetPopup by remember { mutableStateOf(false) }
    var isDashboardExpanded by remember { mutableStateOf(AppGlobal.isDashboardChatbotExpanded) }

    LaunchedEffect(isDashboardExpanded) {
        AppGlobal.isDashboardChatbotExpanded = isDashboardExpanded
    }

    LaunchedEffect(Unit) {
        if (AppGlobal.userData.payment.checkout.status != Strings.PAID) {
            try {
                val profileResponse = getProfile(
                    organization = AppGlobal.userData.organization,
                    userID = AppGlobal.userData.uid,
                    seasonID = AppGlobal.selectedSeasonId
                )
                // Guard: only update if data is actually populated
                if (profileResponse.data.uid.isNotBlank()) {
                    AppGlobal.userData = profileResponse.data
                }
            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                debugPrintln("Failed to fetch profile: ${e.message}")
            }
        }

        val userPayment = AppGlobal.userData.payment.checkout
        val coachPayment = AppGlobal.userData.clubPayment

        val isUnexpired = isPaymentActive(userPayment.expiredOn)
        val isCoachUnexpired = isPaymentActive(coachPayment.expiredOn)

        isPaidAndUnexpired = userPayment.status == Strings.PAID && isUnexpired
        isCoachPaidAndUnexpired = coachPayment.status == Strings.PAID && isCoachUnexpired
    }

    LaunchedEffect(AppGlobal.seasonUpdate) {
        try {
            val seasonData = getClubSeason(
                organization = AppGlobal.userData.organization,
                seasonID = localStorage.getItem("selectedSeasonId") ?: ""
            )
            seasonDataList.clear()
            seasonDataList.addAll(seasonData.data)

            // Correct filter for coach - using seasonID from SeasonList
            val allowedSeasons = if (AppGlobal.userData.role == Strings.COACH) {
                val allowedSeasonIds = AppGlobal.userData.seasons.map { it.seasonID }
                seasonDataList.filter { season ->
                    allowedSeasonIds.contains(season.id)
                }
            } else {
                seasonDataList
            }

            val showDefaultSeason =
                isBeforeCutoff(if (AppGlobal.userData.role == Strings.ADMIN) AppGlobal.userData.payment.checkout.paidOn else AppGlobal.userData.clubPayment.paidOn)
            val restoredId = localStorage.getItem("selectedSeasonId") ?: ""
            val restoredName = localStorage.getItem("selectedSeason") ?: ""

            // Check for Default Season first
            val isDefaultSeasonRestored = restoredId == "" && restoredName == Strings.DEFAULT_SEASON

            val restoredStillExists = if (restoredId.isNotBlank()) {
                allowedSeasons.any { it.id == restoredId }
            } else {
                false
            }

            when {
                // Restore Default Season
                isDefaultSeasonRestored && showDefaultSeason -> {
                    AppGlobal.selectedSeason = Strings.DEFAULT_SEASON
                    AppGlobal.selectedSeasonId = ""
                    // Keep localStorage as is (already has empty ID and DEFAULT_SEASON name)
                }
                // Restore regular season with valid ID
                restoredId.isNotBlank() && restoredStillExists -> {
                    AppGlobal.selectedSeasonId = restoredId
                    AppGlobal.selectedSeason = restoredName
                }
                // Fallback to active season
                allowedSeasons.any { it.status.lowercase() == Strings.ACTIVE } -> {
                    val activeSeason =
                        allowedSeasons.first { it.status.lowercase() == Strings.ACTIVE }
                    AppGlobal.selectedSeasonId = activeSeason.id
                    AppGlobal.selectedSeason = activeSeason.name
                    localStorage.setItem("selectedSeasonId", activeSeason.id)
                    localStorage.setItem("selectedSeason", activeSeason.name)
                }
                // Fallback to first available season
                allowedSeasons.isNotEmpty() -> {
                    val firstSeason = allowedSeasons.first()
                    AppGlobal.selectedSeasonId = firstSeason.id
                    AppGlobal.selectedSeason = firstSeason.name
                    localStorage.setItem("selectedSeasonId", firstSeason.id)
                    localStorage.setItem("selectedSeason", firstSeason.name)
                }
                // Last resort - Default Season
                showDefaultSeason -> {
                    AppGlobal.selectedSeason = Strings.DEFAULT_SEASON
                    AppGlobal.selectedSeasonId = ""
                    localStorage.setItem("selectedSeason", Strings.DEFAULT_SEASON)
                    localStorage.setItem("selectedSeasonId", "")
                }
            }

            AppGlobal.updateNotifications = getCurrentMilliseconds().toString()
            apiFetchTrigger++
        } catch (ce: CancellationException) {
            throw ce
        } catch (e: Throwable) {
            debugPrintln("Error fetching clubSeason: ${e.message}")
        }
    }

    val languageType = when (selectedLanguage) {
        SelectedLanguage.English -> "en"
        SelectedLanguage.Italian -> "it"
    }
    var sessionDataType by remember(selectedDataType) {
        mutableStateOf(
            when (selectedDataType) {
                SelectedData.Training -> Strings.TRAINING
                SelectedData.Matches -> Strings.MATCH
            }
        )
    }

    // LAUNCHED EFFECT 1: Load Performance & Keywords FIRST (Independent)
    LaunchedEffect(AppGlobal.selectedSeasonId, languageType, sessionDataType, apiFetchTrigger) {
        localStorage.setItem("selectedLanguage", languageType)
        localStorage.setItem("selectedDataType", sessionDataType)
        // Skip if season not initialized
        if (apiFetchTrigger == 0) return@LaunchedEffect

        // Show loading for charts
        isChartLoading = true
        isKeywordLoading = true

        // Fetch Performance & Keywords in parallel - THESE RUN IMMEDIATELY
        scope.launch {
            try {
                // Run both APIs in parallel
                val performanceDeferred = async {
                    getClubPerformance(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = languageType,
                        sessionType = sessionDataType,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                }

                val keywordDeferred = async {
                    getClubKeyword(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        sessionType = sessionDataType,
                        language = languageType,
                        keyword = "",
                        getSentences = false,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                }

                // Wait for both to complete
                val performanceResult = performanceDeferred.await()
                val keywordResult = keywordDeferred.await()

                // Update Performance Chart
                performanceResult?.let {
                    performanceResponse = it.data
                    isChartLoading = false
                }

                // Update Keywords Chart
                keywordResult.let {
                    keywordResponse.clear()
                    keywordResponse.addAll(it.data)
                    isKeywordLoading = false
                }

            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                debugPrintln("Error loading charts: ${e.message}")
                isChartLoading = false
                isKeywordLoading = false
            }
        }
    }

    val widgetIdMap = mapOf(
        "coach_talk_ratio" to 1,
        "session_intensity" to 2,
        "game_realism" to 3,
        "development_orientation" to 4,
        "tactical_complexity" to 5,
        "topic_diversity" to 6,
        "methodology_consistency" to 7,
        "cognitive_training" to 8,
        "competitive_environment" to 9,
        "match_analysis" to 10
    )


// LAUNCHED EFFECT 2: Load All Other Data (Updates UI as each completes)
    LaunchedEffect(AppGlobal.selectedSeasonId, languageType, sessionDataType, apiFetchTrigger) {
        localStorage.setItem("selectedLanguage", languageType)
        localStorage.setItem("selectedDataType", sessionDataType)
        if (apiFetchTrigger == 0) return@LaunchedEffect

        scope.launch {
            debugPrintln("🟡 Loading other data started")

            // Start ALL APIs in parallel - DON'T await them yet
            val profileDeferred = async {
                try {
                    getProfile(
                        organization = AppGlobal.userData.organization,
                        userID = AppGlobal.userData.uid,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                } catch (ce: CancellationException) {
                    throw ce  // Re-throw to properly cancel the coroutine
                } catch (e: Exception) {
                    debugPrintln("Failed to fetch profile: ${e.message}")
                    null
                }
            }

            val clubWidgetsDeferred = async {
                try {
                    getClubWidgets(
                        GetClubWidgetPayload(
                            organization = AppGlobal.userData.organization
                        )
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Failed to fetch profile: ${e.message}")
                    null
                }
            }

            val customKeywordDeferred = async {
                try {
                    getCustomKeyword(
                        payload = CustomKeywordPayload(
                            AppGlobal.userData.organization,
                            seasonID = AppGlobal.selectedSeasonId
                        ),
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Error fetching customKeyword: ${e.message}")
                    null
                }
            }

            val coachesDeferred = async {
                try {
                    getClubCoaches(
                        AppGlobal.userData.organization,
                        "soccer",
                        sessionDataType,
                        languageType,
                        AppGlobal.selectedSeasonId
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Failed to fetch club coaches: ${e.message}")
                    null
                }
            }

            val sessionDeferred = async {
                try {
                    getClubSession(
                        organization = AppGlobal.userData.organization,
                        sessionType = sessionDataType,
                        domainType = "soccer",
                        language = languageType,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Error fetching clubSession: ${e.message}")
                    null
                }
            }

            val playerDeferred = async {
                try {
                    getPlayerAggregate(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = "en",
                        seasonID = AppGlobal.selectedSeasonId,
                        team = emptyList()
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Error fetching playerAggregate: ${e.message}")
                    null
                }
            }

            val teamsDeferred = async {
                try {
                    getAllTeams(
                        clubName = AppGlobal.userData.organization,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Error fetching allTeams: ${e.message}")
                    null
                }
            }

            val clubWidgetDeferred = async {
                try {
                    getClubWidgetData(
                        ClubWidgetPayload(
                            organization = AppGlobal.userData.organization,
                            seasonId = AppGlobal.selectedSeasonId,
                        )
                    )
                } catch (ce: CancellationException) {
                    throw ce
                } catch (e: Exception) {
                    debugPrintln("Failed to fetch club widget data: ${e.message}")
                    null
                }
            }

//            val customNamesDeferred = async {
//                try {
//                    getCustomNames(
//                        payload = CustomNamesPayload(
//                            organization = AppGlobal.userData.organization
//                        )
//                    )
//                } catch (ce: CancellationException) {
//                    throw ce
//                } catch (e: Exception) {
//                    debugPrintln("Error fetching custom names: ${e.message}")
//                    null
//                }
//            }

//            val clubNamesDeferred = async {
//                try {
//                    getClubNames(
//                        payload = ClubNamesPayload(
//                            organization = AppGlobal.userData.organization,
//                            domainType = "soccer",
//                            language = "en",
//                            keyword = "",
//                            getSentences = false,
//                            seasonId = AppGlobal.selectedSeasonId
//                        )
//                    )
//                } catch (e: Exception) {
//                    null
//                }
//            }

            // FIX: Update UI as SOON as each API completes (don't wait for others)

            // Handle Coaches ASAP - don't wait for others
            launch {
                val coachesResult = coachesDeferred.await()
                coachesResult?.let {
                    it.data.forEach { item ->
                        val efficiency = if (item.speakingTime > 0) {
                            item.totalKeywords / item.speakingTime
                        } else {
                            0.0
                        }
                        item.efficiency = (efficiency * 100)
                    }
                    clubCoachesList.clear()
                    clubCoachesList.addAll(it.data)
                }
            }

            // Handle Sessions ASAP
            launch {
                val sessionResult = sessionDeferred.await()
                sessionResult?.let {
                    val sortedData = it.data.sortedByDescending { sessionData ->
                        val parts = sessionData.sessionId.removeSuffix(".aac").split("_")
                        parts.last()
                    }
                    clubSessionList.clear()
                    clubSessionList.addAll(sortedData)
                }
            }

            // Handle Players ASAP
            launch {
                val playerResult = playerDeferred.await()
                playerResult?.let {
                    clubPlayersList = it.data.toList()
                    AppGlobal.clubPlayersList.clear()
                    AppGlobal.clubPlayersList.addAll(clubPlayersList)
                }
            }

            // Handle Teams ASAP
            launch {
                val teamsResult = teamsDeferred.await()
                teamsResult?.let {
                    teamDataList.clear()
                    teamDataList.addAll(it.data)
                }
            }

            // Handle remaining APIs in background (don't block UI)
            launch {
                val profileResult = profileDeferred.await()
                profileResult?.let {
                    if (it.data.uid.isNotBlank()) {
                        AppGlobal.userData = it.data
                    }
                }
            }

            launch {
                val customKeywordResult = customKeywordDeferred.await()
                customKeywordResult?.let {
                    clubKeywordsList.clear()
                    clubKeywordsList.addAll(it.data)
                }
            }

            launch {
                val widgetResult = clubWidgetDeferred.await()

                widgetResult?.let {
                    clubWidgetResponse = it
                }
            }

            launch {
                val widgetConfigResult = clubWidgetsDeferred.await()

                if (widgetConfigResult == null) {
                    selectedWidgetIds = defaultWidgetIds
                    tempSelectedWidgetIds = defaultWidgetIds
                    return@launch
                }
                val apiWidgets =
                    if (widgetConfigResult.selectedWidgets.isNullOrEmpty()) {
                        defaultWidgetIds
                    } else {
                        widgetConfigResult.selectedWidgets
                            .mapNotNull { widgetIdMap[it] }
                            .toSet()
                            .ifEmpty { defaultWidgetIds }
                    }

                selectedWidgetIds = apiWidgets
                tempSelectedWidgetIds = apiWidgets
            }
//
//            launch {
//                val customNamesResult = customNamesDeferred.await()
//                customNamesResult?.let {
//                    customNamesList.clear()
//                    customNamesList.addAll(it.data)
//                }
//            }

//            launch {
//                val clubNamesResult = clubNamesDeferred.await()
//                clubNamesResult?.let {
//                    AppGlobal.clubNameDataList.clear()
//                    AppGlobal.clubNameDataList.addAll(it.data)
//                }
//            }

            debugPrintln("✅ All APIs started - UI will update as each completes")
        }
    }

//    LaunchedEffect(AppGlobal.selectedSeasonId, languageType, sessionDataType, apiFetchTrigger) {
//        localStorage.setItem("selectedLanguage", languageType)
//        localStorage.setItem("selectedDataType", sessionDataType)
//        if (apiFetchTrigger == 0) return@LaunchedEffect
//
//        fetchData(
//            language = languageType,
//            sessionType = sessionDataType,
//            seasonID = AppGlobal.selectedSeasonId
//        )
//    }

    LaunchedEffect(AppGlobal.refreshPlayerList) {
        if (apiFetchTrigger == 0) return@LaunchedEffect

        try {
            val playerData = getPlayerAggregate(
                organization = AppGlobal.userData.organization,
                domainType = "soccer",
                language = "en",
                seasonID = AppGlobal.selectedSeasonId,
                team = emptyList()
            )
            clubPlayersList = playerData.data.toList()
            AppGlobal.clubPlayersList.clear()
            AppGlobal.clubPlayersList.addAll(clubPlayersList)
        } catch (ce: CancellationException) {
            throw ce
        } catch (e: Throwable) {
            debugPrintln("Error fetching playerAggregate: ${e.message}")
        }
    }

    val data = localStorage.getItem("userData")
    if (data == null) {
        ctx.router.navigateTo("/login")
        return
    }
    //
    if (AppGlobal.userData.role == Strings.PLAYER) {
        ctx.router.navigateTo("/player-details")
        return
    }
    if (AppGlobal.userData.role == Strings.COACH && AppGlobal.userData.organization == Strings.INDEPENDENT) {
        ctx.router.navigateTo("/coach-details?userId=${AppGlobal.userData.uid}")
        return
    }
    //

    fun refreshTeam() {
        scope.launch {
            try {
                val teamResponse = getAllTeams(
                    clubName = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId
                )
                teamDataList.clear()
                teamDataList.addAll(teamResponse.data)
            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                debugPrintln("Error refreshing teams: ${e.message}")
            }
        }
    }
    if (isRecommendationPopupVisible) {
        RecommendationPopup(
            onDialogDismiss = {
                isRecommendationPopupVisible = false
            },
            breakpoint = breakpoint,
            modalNumber = 1,
            data = selectedCoach,
            language = languageType,
            sessionType = sessionDataType

        )

    }
    if (isPlayerRecommendationVisible) {
        PlayerRecommendationPopup(
            onDialogDismiss = {
                isPlayerRecommendationVisible = false
            },
            breakpoint = breakpoint,
            modalNumber = 2,
            language = languageType,
            data = selectedPlayer,
        )
    }
    if (isNewPlayerPopup) {
        AddNewPlayer(
            onDialogDismiss = {
                isNewPlayerPopup = false
            },
            breakpoint = breakpoint,
            modalNumber = 1,
            toastMessageCall = { message = it },
            teamData = teamDataList,
            onPlayerAdded = { newPlayersList ->
                clubPlayersList = newPlayersList
            }
        )

    }
    if (isNewCoachPopup) {
        AddNewCoach(
            onDialogDismiss = {
                isNewCoachPopup = false
            },
            onSave = {
                scope.launch {
                    val updatedCoach = getClubCoaches(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = languageType,
                        sessionType = sessionDataType,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                    clubCoachesList.clear()
                    clubCoachesList.addAll(updatedCoach.data)

                }
            },
            breakpoint = breakpoint,
            modalNumber = 1,
            toastMessageCall = { message = it },
            onLimitReach = {
                isNewCoachPopup = false

                coachLimitReached = true
            }
        )
    }
    if (coachLimitReached) {
        CoachLimitReachedPopup(
            onDialogDismiss = { coachLimitReached = false },
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            onClick = {
                coachLimitReached = false
                caochesCount = true
            }
        )
    }
    if (caochesCount) {
        CoachesCount(
            onDialogDismiss = { caochesCount = false },
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            toastMessage = { message = it }
        )
    }
    if (importPlayers) {
        ImportEntity(
            isCoach = false,
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            toastMessage = { message = it },
            onDialogDismiss = {
                importPlayers = false
                AppGlobal.seasonUpdate = getCurrentMilliseconds()
                scope.launch {
                    val response = getPlayerAggregate(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = languageType,
                        seasonID = AppGlobal.selectedSeasonId,
                        team = emptyList()

                    )
                    clubPlayersList = response.data.toList()


                    //                    --------
                    refreshTeam()
                }
            },
            playerData = clubPlayersList,
            buyCoaches = {}

        )
    }
    if (importCoach) {
        ImportEntity(
            isCoach = true,
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            toastMessage = { message = it },
            onDialogDismiss = {
                importCoach = false
                AppGlobal.seasonUpdate = getCurrentMilliseconds()
                scope.launch {
                    val response = getClubCoaches(
                        organization = AppGlobal.userData.organization,
                        domainType = "soccer",
                        language = languageType,
                        sessionType = sessionDataType,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                    clubCoachesList.clear()
                    clubCoachesList.addAll(response.data)

                    //                    --------
                    refreshTeam()
                }

            },
            coachesData = clubCoachesList,
            buyCoaches = {
                importCoach = false
                coachLimitReached = true
            }
        )
    }
    if (deleteSeason) {
        DeleteSeason(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            modalNumber = 2,
            onDialogDismiss = {
                if (it) AppGlobal.seasonUpdate = getCurrentMilliseconds()
                deleteSeason = false
            },
            toastMessageCall = { message = it },
            seasonId = selectedSeason,
        )
    }
    if (isClubSeason) {
        CreateClubSeason(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            modalNumber = 1,
            isEditMode = isEditMode,
            seasonData = selectedSeasonData,
            onDialogDismiss = {
                AppGlobal.seasonUpdate = getCurrentMilliseconds()
                isClubSeason = false
            },
            toastMessageCall = { message = it },
            onCloses = { isClubSeason = false },
            disableActiveField1 = seasonDataList.isEmpty() || selectedSeasonData.status == Strings.ACTIVE
        )
    }
    LaunchedEffect(AppGlobal.refreshSessions) {
        if (AppGlobal.refreshSessions.isNotEmpty()) {
            try {
                isLoading = true

                val user = getClubCoaches(
                    organization = AppGlobal.userData.organization,
                    domainType = "soccer",
                    sessionType = sessionDataType,
                    language = languageType,
                    seasonID = AppGlobal.selectedSeasonId
                )

                user.data.forEach { item ->
                    val efficiency =
                        if (item.speakingTime > 0)
                            item.totalKeywords / item.speakingTime
                        else 0.0

                    item.efficiency = efficiency * 100
                }

                clubCoachesList.clear()
                clubCoachesList.addAll(user.data)

            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                debugPrintln("Error refreshing coaches: $e")
            } finally {
                isLoading = false
            }
        }
    }


    //

    if (!isPaidAndUnexpired && AppGlobal.userData.role == Strings.ADMIN) {
        AnnualSubscriptionsPayment(
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            toastMessage = { message = it },
        )
    }

    if (!isCoachPaidAndUnexpired && AppGlobal.userData.role == Strings.COACH) {
        ClubCoachPaymentPopup(
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            ctx = ctx
        )
    }

    if (showWidgetValidationPopup) {
        WidgetSelectionValidationPopup(
            currentCount = tempSelectedWidgetIds.size,
            onChooseMore = {
                // Close validation popup, keep selection popup open
                showWidgetValidationPopup = false
            },
            onKeepFour = {
                // Trim to 4 and save
                val trimmedToFour = tempSelectedWidgetIds.sorted().take(4).toSet()
                tempSelectedWidgetIds = trimmedToFour
                selectedWidgetIds = trimmedToFour
                showWidgetValidationPopup = false
            }
        )
    }


    val dashboardWidgetRenderers = rememberWidgetRenderers(
        widgetData = clubWidgetResponse?.clubAverages,
        showSelection = false,
        selectedIds = selectedWidgetIds ?: emptySet()
    ) { _, _ -> }

    val popupWidgetRenderers = rememberWidgetRenderers(
        widgetData = clubWidgetResponse?.clubAverages,
        showSelection = true,
        selectedIds = tempSelectedWidgetIds
    ) { id, checked ->

        tempSelectedWidgetIds =
            if (checked)
                tempSelectedWidgetIds + id
            else
                tempSelectedWidgetIds - id
    }

    Box(Modifier.fillMaxSize()) {
        Column(
            Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackground.rgb)
                .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
                .id(Res.Id.dashboradPage)
        ) {
            BSToastGroupCustom(
                placement = ToastPlacement.TopRight,
            ) {
                BSToastBasicCustom(
                    id = "toastSuccess",
                    text = message,
                    style = ToastStyle.Success,
                    autoHide = true,
                    closeButtonDark = false,
                    onCloseClick = {}
                )
                BSToastBasicCustom(
                    id = "toastError",
                    text = message,
                    style = ToastStyle.Danger,
                    autoHide = true,
                    closeButtonDark = false,
                    onCloseClick = {}
                )
            }
            DashboardHeaderSection(
                toastMessage = { message = it },
                clubButton = false,
                coachButton = AppGlobal.userData.role == Strings.COACH,
            )
            Column(
                modifier = Modifier.fillMaxHeight()
                    .fillMaxWidth(if (window.screen.width > 1800) 1700.px else 100.percent)
                    .padding(leftRight = if (breakpoint >= Breakpoint.LG) 60.px else 20.px)
                    .align(Alignment.CenterHorizontally),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                        .margin(top = 10.px, bottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    SpanText(
                        "Dashboard", modifier = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontWeight(700)
                            .fontSize(26.px)
                            .margin(right = 20.px)
                    )
                    Row(
                        modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 172.px else 188.px)
                            .height(42.px)
                            .borderRadius(6.px)
                            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                            .padding(leftRight = 5.px, topBottom = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.LightGray
                            ),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SelectedBox(
                            text = "Training",
                            breakpoint = breakpoint,
                            width = 87.px,
                            height = 34.px,
                            fontSize = 16.px,
                            fontWeight = 500,
                            isSelected = selectedDataType == SelectedData.Training,
                            onClick = {
                                selectedDataType = SelectedData.Training
                            })
                        SelectedBox(
                            text = "Matches",
                            breakpoint = breakpoint,
                            width = 87.px,
                            height = 34.px,
                            fontSize = 16.px,
                            fontWeight = 500,
                            isSelected = selectedDataType == SelectedData.Matches,
                            onClick = {
                                selectedDataType = SelectedData.Matches
                            })

                    }
                    Spacer()
                    Row(
                        modifier = Modifier.margin(top = if (breakpoint < Breakpoint.MD) 10.px else 0.px)
                            .width(
                                if (breakpoint > Breakpoint.LG) 16.percent
                                else if (breakpoint >= Breakpoint.LG) 18.percent
                                else if (breakpoint >= Breakpoint.MD) 24.percent
                                else 54.percent
                            )
                    ) {
                        val showDefaultSeason =
                            isBeforeCutoff(AppGlobal.userData.payment.checkout.paidOn)

                        // ✅ Correct filter for coach - using seasonID from SeasonList
                        val allowedSeasons = if (AppGlobal.userData.role == Strings.COACH) {
                            val allowedSeasonIds =
                                AppGlobal.userData.seasons.map { it.seasonID } // Extract seasonID strings
                            seasonDataList.filter { season ->
                                allowedSeasonIds.contains(season.id)
                            }
                        } else {
                            seasonDataList
                        }

                        val seasonOptions = mutableListOf<String>().apply {
                            if (showDefaultSeason) add(Strings.DEFAULT_SEASON)
                            addAll(allowedSeasons.map { it.name })
                        }

                        val validSelectedSeason = when {
                            AppGlobal.selectedSeason == Strings.DEFAULT_SEASON -> Strings.DEFAULT_SEASON
                            allowedSeasons.any { it.id == AppGlobal.selectedSeasonId } -> AppGlobal.selectedSeason
                            allowedSeasons.isNotEmpty() -> allowedSeasons.first().name
                            showDefaultSeason -> Strings.DEFAULT_SEASON
                            else -> ""
                        }

                        SeasonSelectorPopover(
                            isAdmin = AppGlobal.userData.role == Strings.ADMIN,
                            seasons = allowedSeasons,
                            showDefaultSeason = showDefaultSeason,
                            selectedSeasonId = AppGlobal.selectedSeasonId,

                            onSelect = { season ->
                                if (season != null) {
                                    AppGlobal.selectedSeason = season.name
                                    AppGlobal.selectedSeasonId = season.id
                                    localStorage.setItem("selectedSeason", season.name)
                                    localStorage.setItem("selectedSeasonId", season.id)
                                } else {
                                    AppGlobal.selectedSeason = Strings.DEFAULT_SEASON
                                    AppGlobal.selectedSeasonId = ""
                                    localStorage.setItem("selectedSeason", Strings.DEFAULT_SEASON)
                                    localStorage.setItem("selectedSeasonId", "")
                                }
                            },

                            onAddSeason = {
                                isClubSeason = true
                                isEditMode = false
                            },

                            onEditSeason = { season ->
                                selectedSeasonData = season
                                isEditMode = true
                                isClubSeason = true
                            },

                            onDeleteSeason = { season ->
                                selectedSeason = season.id
                                deleteSeason = true
                            },
                            breakpoint = breakpoint
                        )
                    }
                    CustomSpacer(width = 10.px)
                    Box(
                        modifier = Modifier
                            .borderRadius(6.px)
                            .border(1.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                            .padding(leftRight = 16.px, topBottom = 6.px)
                            .margin(top = if (breakpoint < Breakpoint.MD) 10.px else 0.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                try {
                                    val clipboard = window.navigator.clipboard
                                    clipboard.writeText(AppGlobal.userData.organization)
                                    message = "Club ID copied!"
                                    showToast(ToastID.SUCCESS)
                                } catch (e: Throwable) {
                                    debugPrintln("Failed to copy: ${e.message}")
                                }
                            }

                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            FaCopy(modifier = Modifier.margin(right = 6.px), size = IconSize.SM)
                            FieldTitleTextNormalSimple(
                                "Copy Club ID",
                                fontSize = 14.px,
                                fontWeight = 500,
                                isClickable = true
                            )
                        }
                    }
                    Box(
                        modifier = Modifier
                            .borderRadius(6.px)
                            .border(1.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                            .padding(leftRight = 16.px, topBottom = 6.px)
                            .margin(
                                top = if (breakpoint <= Breakpoint.MD) 10.px else 0.px,
                                left = if (breakpoint <= Breakpoint.MD) 0.px else 10.px
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                tempSelectedWidgetIds = selectedWidgetIds ?: emptySet()
                                showWidgetPopup = true
                            },
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            FaGear(modifier = Modifier.margin(right = 6.px), size = IconSize.SM)
                            FieldTitleTextNormalSimple(
                                "Manage Widgets",
                                fontSize = 14.px,
                                fontWeight = 500,
                                isClickable = true
                            )
                        }
                    }
                    //                    SelectedBox(
                    //                        text = "English",
                    //                        breakpoint = breakpoint,
                    //                        isSelected = selectedLanguage == SelectedLanguage.English,
                    //                        onClick = { selectedLanguage = SelectedLanguage.English
                    //                        }
                    //                    )
                    //                    SelectedBox(
                    //                        text = "Italian",
                    //                        breakpoint = breakpoint,
                    //                        isSelected = selectedLanguage == SelectedLanguage.Italian,
                    //                        onClick = { selectedLanguage = SelectedLanguage.Italian }
                    //                    )
                }
//                InfoLayout(
//                    clubCoachesList, openNewWindow = { openNewWindow = true },
//                    breakpoint, teamData = teamDataList,
//                    sessionType = sessionDataType
//                )
//                Row(modifier = Modifier.fillMaxWidth()) {
//                    Spacer()
//                    CommonButton(
//                        text = "Add New Widgets",
//                        icon = {
//                            FaPlus(
//                                size = IconSize.X1,
//                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
//                            )
//                        },
//                        width = 150.px,
//                        height = 40.px,
//                        onCLick = {
//                            tempSelectedWidgetIds = selectedWidgetIds
//                            showWidgetPopup = true
//                        })
//                }
//                Row(
//                    modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
//                        .margin(topBottom = 10.px),
//                    verticalAlignment = Alignment.CenterVertically,
//                    horizontalArrangement = Arrangement.SpaceBetween
//                ) {
//                    ClubPerformance(
//                        performanceResponse,
//                        breakpoint,
//                        selectedLanguage,
//                        isChartLoading
//                    )
//                    EmphasisBreakdown(
//                        keywordResponse,
//                        selectedLanguage,
//                        breakpoint,
//                        isKeywordLoading
//                    )
//                }

                val widgetKeyMap = mapOf(
                    1 to "coach_talk_ratio",
                    2 to "session_intensity",
                    3 to "game_realism",
                    4 to "development_orientation",
                    5 to "tactical_complexity",
                    6 to "topic_diversity",
                    7 to "methodology_consistency",
                    8 to "cognitive_training",
                    9 to "competitive_environment",
                    10 to "match_analysis"
                )

                if (selectedWidgetIds != null) {
                    val sortedSelectedIds = selectedWidgetIds!!.sorted()
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .flexWrap(FlexWrap.Wrap)
                            .gap(12.px)
                            .margin(topBottom = 10.px)
                    ) {
                        sortedSelectedIds.forEachIndexed { index, id ->
                            dashboardWidgetRenderers[id]?.invoke(index + 1)
                        }
                    }
                }
                if (showWidgetPopup) {
                    WidgetSelectionPopup(
                        selectedIds = tempSelectedWidgetIds,
                        isLoading = isWidgetLoading,
                        onClose = {
                            showWidgetPopup = false
                        },
                        onSave = {
                            val count = tempSelectedWidgetIds.size
                            when {
                                count in 0..3 -> {
                                    showWidgetValidationPopup = true
                                }

                                count in 5..7 -> {
                                    showWidgetValidationPopup = true
                                }

                                count > 8 -> {
                                    showWidgetValidationPopup = true
                                }

                                else -> {
                                    // Valid: count is 4 or 8
                                    scope.launch {
                                        try {
                                            isWidgetLoading = true

                                            val selectedWidgets = tempSelectedWidgetIds
                                                .sorted()
                                                .mapNotNull { widgetKeyMap[it] }

                                            val response = saveWidgetConfig(
                                                SaveWidgetPayload(
                                                    organization = AppGlobal.userData.organization,
                                                    selectedWidgets = selectedWidgets
                                                )
                                            )

                                            selectedWidgetIds = tempSelectedWidgetIds
                                            showWidgetPopup = false

                                            message = "Widgets saved successfully"
                                            showToast(ToastID.SUCCESS)

                                            debugPrintln("Widget saved: ${response.data}")

                                        } catch (e: Exception) {
                                            message = e.message ?: "Failed to save widgets"
                                            showToast(ToastID.ERROR)
                                        } finally {
                                            isWidgetLoading = false
                                        }
                                    }
                                }
                            }
                        }
                    ) {
                        // Widget selection is available on ALL screens
                        val allWidgetIds = (1..10).toList()
                        if (window.screen.width > 1440) {
                            // Above 1440px: Split into chunks of 5 (2 rows of 5)
                            allWidgetIds.chunked(5).forEachIndexed { index, chunk ->
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .flexWrap(FlexWrap.Wrap)
                                        .gap(10.px)
                                        .margin(bottom = if (index == 0) 12.px else 0.px)
                                ) {
                                    chunk.forEach { id ->
                                        popupWidgetRenderers[id]?.invoke(id)
                                    }
                                }
                            }
                        } else {
                            // Below 1440px: Show all 10 widgets in a single row (or wrapped)
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .flexWrap(FlexWrap.Wrap)
                                    .gap(12.px)
                            ) {
                                allWidgetIds.forEach { id ->
                                    popupWidgetRenderers[id]?.invoke(id)
                                }
                            }
                        }
                    }
                }

                Row(
                    modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                        .margin(topBottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    //
                    Column(
                        modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 0.px else 15.px)
                            .width(
                                if (breakpoint > Breakpoint.LG) 68.percent
                                else if (breakpoint == Breakpoint.LG) 100.percent
                                else if (breakpoint > Breakpoint.MD) 54.percent
                                else 100.percent
                            )
                    ) {
                        KeywordUsage(
                            keywordResponse,
                            selectedLanguage,
                            toastMessage = { message = it })
//                        NamesSection(
//                            clubNamesData = AppGlobal.clubNameDataList,  // Pass the data from parent
//                            customNamesList = customNamesList,  // Pass custom names
//                            selectedLanguage = selectedLanguage,
//                            toastMessage = { message = it }
//                        )
                    }
                    if (breakpoint < Breakpoint.MD && AppGlobal.userData.role == Strings.ADMIN) {
                        ResponsiveDashboardChatbot(
                            onDismiss = { isChatOpen = false },
                            breakpoint = breakpoint,
                            sitePalette = sitePalette,
                            userId = AppGlobal.userData.uid,
                            getCoachInfo = coachProfile ?: GetSingleCoachData(),
                            selectedSessionType = selectedDataType,
                            selectedLanguage = selectedLanguage,
                            sessionList = allSessions,
                            showOverlay = showOverlay,
                            onShowOverlayChange = { showOverlay = it },
                            subscriptionPopup = { subscriptionPopup = it },
                            playersList = coachPlayerList,
                            performanceResponse = performanceResponse
                        )
                    }
                    Column(
                        modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 0.px else 15.px)
                            .width(
                                if (breakpoint > Breakpoint.LG) 30.percent
                                else 100.percent
                            )
                    ) {
//                        SeasonSection(
//                            breakpoint,
//                            sitePalette,
//                            message = { message = it },
//                            seasonData = seasonDataList,
//                            onSave = { isDelete ->
//                                if (isDelete) {
//
//                                    val currentSelectedId = AppGlobal.selectedSeasonId
//
//                                    val activeSeason =
//                                        seasonDataList.find { it.status.lowercase() == Strings.ACTIVE }
//                                    val fallbackSeason =
//                                        activeSeason ?: seasonDataList.firstOrNull()
//
//                                    // If selected season was deleted OR selection empty → reassign
//                                    val selectedStillExists =
//                                        seasonDataList.any { it.id == currentSelectedId }
//
//                                    if (!selectedStillExists || currentSelectedId.isEmpty()) {
//
//                                        if (fallbackSeason != null) {
//                                            AppGlobal.selectedSeasonId = fallbackSeason.id
//                                            AppGlobal.selectedSeason = fallbackSeason.name
//                                        } else {
//                                            AppGlobal.selectedSeasonId = ""
//                                            AppGlobal.selectedSeason = ""
//                                        }
//
//                                        localStorage.setItem(
//                                            "selectedSeasonId",
//                                            AppGlobal.selectedSeasonId
//                                        )
//                                        localStorage.setItem(
//                                            "selectedSeason",
//                                            AppGlobal.selectedSeason
//                                        )
//                                    }
//
//                                }
//                                AppGlobal.seasonUpdate = getCurrentMilliseconds()
//                            }
//                        )
                        TeamSections(
                            breakpoint,
                            sitePalette,
                            teamDataList,
                            message = { message = it })
                    }
                }

                // Chatbot UI
                if (breakpoint >= Breakpoint.MD && AppGlobal.userData.role == Strings.ADMIN) {
                    DashboardChatbot(
                        onDismiss = { isChatOpen = false },
                        isChatOpen = false,
                        onExpandToggle = { isChatOpen = true },
                        isDashboardExpanded = isDashboardExpanded,
                        onDashboardExpandToggle = {
                            isDashboardExpanded = !isDashboardExpanded
                            AppGlobal.isDashboardChatbotExpanded = !isDashboardExpanded
                        },
                        breakpoint = breakpoint,
                        sitePalette = sitePalette,
                        userId = AppGlobal.userData.uid,
                        getCoachInfo = coachProfile ?: GetSingleCoachData(),
                        selectedSessionType = selectedDataType,
                        selectedLanguage = selectedLanguage,
                        sessionList = allSessions,
                        showOverlay = showOverlay,
                        onShowOverlayChange = { showOverlay = it },
                        subscriptionPopup = { subscriptionPopup = it },
                        playersList = coachPlayerList,
                        performanceResponse = performanceResponse,
                        toastMessage = { message = it },
                        scrollContainerId = Res.Id.dashboardScrollContainer,
                        messageInputId = Res.Id.dashboardMessageInput,
                        chatState = chatState
                    )
                }

                Row(
                    modifier = Modifier.fillMaxWidth()
                        .margin(topBottom = if (breakpoint < Breakpoint.MD) 0.px else 10.px)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    CoachesLayout(
                        clubCoachesList,
                        clubPlayersList,
                        breakpoint,
                        onCoachesRecommendationClick = { data ->
                            selectedCoach = data
                            isRecommendationPopupVisible = true
                        },
                        onPlayerRecommendationClick = { data ->
                            selectedPlayer = data
                            isPlayerRecommendationVisible = true
                        },
                        addNewCoach = { isNewCoachPopup = true },
                        addNewPlayer = { isNewPlayerPopup = true },
                        toastMessageCall = { message = it },
                        importPlayer = { importPlayers = true },
                        importCoach = { importCoach = true },
                        onLimitReach = {
                            coachLimitReached = true
                        },
                    )
                    Column(
                        modifier = Modifier.gap(if (breakpoint < Breakpoint.MD) 0.px else 15.px)
                            .width(
                                if (breakpoint > Breakpoint.LG) 30.percent
                                else 100.percent
                            )
                    ) {
                        RecentHighlight(clubSessionList, breakpoint)
                    }
                    //                    }


                }
            }
        }

        DashboardChatOverlay(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            isChatOpen = isChatOpen,
            onDismiss = {
                isChatOpen = false
            },
            userId = AppGlobal.userData.uid,
            coachProfile = coachProfile,
            selectedDataType = selectedDataType,
            selectedLanguage = selectedLanguage,
            allSessions = allSessions,
            showOverlay = showOverlay,
            onShowOverlayChange = { showOverlay = it },
            subscriptionPopup = { subscriptionPopup = it },
            coachPlayerList = coachPlayerList,
            performanceResponse = performanceResponse,
            chatMessages = chatState
        )
    }
}

@Composable
fun SelectedBox(
    text: String,
    breakpoint: Breakpoint,
    width: CSSLengthNumericValue = 41.px,
    height: CSSLengthNumericValue = 32.px,
    fontWeight: Int = 400,
    fontSize: CSSLengthNumericValue? = null,
    isSelected: Boolean,
    isSelectedColor: Color? = null,
    marginRight: CSSLengthNumericValue = 0.px,
    onClick: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier
            .height(height)
            .width(width)
            .backgroundColor(
                if (isSelected) isSelectedColor ?: sitePalette.primary.rgb
                else sitePalette.modalBackgroundColor.rgb
            )
            .borderRadius(5.px)
            .onClick { onClick() }
            .cursor(Cursor.Pointer)
            .padding(10.px)
            .margin(right = marginRight),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text,
            modifier = Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .fontWeight(fontWeight)
                .color(
                    if (isSelected) sitePalette.modalBackgroundColor.rgb
                    else sitePalette.textFieldSupportiveTextColor.rgb
                )
                .fontSize(fontSize ?: 13.px)
        )
    }
}

@Composable
fun SectionTitle(
    text: String,
    bottom: CSSSizeValue<CSSUnit.px> = 15.px,
    top: CSSSizeValue<CSSUnit.px> = 0.px,
    right: CSSSizeValue<CSSUnit.px> = 0.px,
    left: CSSSizeValue<CSSUnit.px> = 0.px,
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    SpanText(
        text, modifier = Modifier
            .fontFamily(Constants.FONT_FAMILY)
            .fontWeight(600)
            .color(sitePalette.titleColor.rgb)
            .fontSize(if (breakpoint >= Breakpoint.LG) 18.px else 16.px)
            .margin(bottom = bottom, top = top, right = right, left = left)
    )
}
